export const CONG_NO_PERMISSION_CODES = {
  WEB_BH_CONG_NO_KHACH_HANG_LIST: 'WEB_BH_CONG_NO_KHACH_HANG_LIST',
  WEB_BH_CONG_NO_THEO_DON_LIST: 'WEB_BH_CONG_NO_THEO_DON_LIST',
  WEB_BH_CONG_NO_THEO_DON_CHI_TIET_LIST: 'WEB_BH_CONG_NO_THEO_DON_CHI_TIET_LIST',
  WEB_BH_CONG_NO_THANH_TOAN_LIST: 'WEB_BH_CONG_NO_THANH_TOAN_LIST',
  WEB_BH_CONG_NO_HOAN_TIEN_LIST: 'WEB_BH_CONG_NO_HOAN_TIEN_LIST',
  WEB_BH_CONG_NO_GIAO_DICH: 'WEB_BH_CONG_NO_GIAO_DICH',
  WEB_BH_CONG_NO_KHOA: 'WEB_BH_CONG_NO_KHOA',
  WEB_BH_CONG_NO_CHOT: 'WEB_BH_CONG_NO_CHOT',
  WEB_BH_CONG_NO_CHOT_TOAN_BO: 'WEB_BH_CONG_NO_CHOT_TOAN_BO',
  WEB_BH_CONG_NO_IMPORT: 'WEB_BH_CONG_NO_IMPORT',
} as const

/** Quyền xem từng màn công nợ — dùng `hasAny` để biết user có vào được nhóm Công nợ không. */
export const CONG_NO_VIEW_PERMISSIONS = [
  CONG_NO_PERMISSION_CODES.WEB_BH_CONG_NO_KHACH_HANG_LIST,
  CONG_NO_PERMISSION_CODES.WEB_BH_CONG_NO_THEO_DON_LIST,
  CONG_NO_PERMISSION_CODES.WEB_BH_CONG_NO_THEO_DON_CHI_TIET_LIST,
  CONG_NO_PERMISSION_CODES.WEB_BH_CONG_NO_THANH_TOAN_LIST,
  CONG_NO_PERMISSION_CODES.WEB_BH_CONG_NO_HOAN_TIEN_LIST,
] as const
